<template>
  <div id="Index">
    <!-- 导航栏 -->
    <div class="NavBar">
      <div class="Logo">
        <img src="../assets/img/logo.png" alt="" />
      </div>
      <div class="NavMenu">
        <ul class="NavMenu_Ul">
          <li
            v-for="(item, index) in NavMenuItem"
            :key="index"
            @mouseenter="moveNavBarInto($event)"
            @mouseleave="navBarMovedOut($event)"
            @click="clickNavBar($event, index)"
          >
            <p></p>
            <span>{{ item }}</span>
            <p></p>
          </li>
        </ul>
      </div>
      <!-- <div class="fccLogo">
        <a href="http://axyh.youyihu.cn:9200" target="_blank">
          <img src="../assets/img/ffclogo.png" alt="" />
        </a>
      </div> -->
      <div></div>
    </div>

    <!-- 左下角文字滚动 -->
    <!-- <div class="text-container" v-show="scrollingShow">
      <div class="News_down" @click="clickToNextSlide()"></div>
      <div class="News_content">
        <span>News:</span>
        <transition class="inner-container2" name="slide" mode="out-in">
          <router-link
            tag="a"
            :to="{ path: '/News', query: { id: text.id } }"
            target="_blank"
            class="text2"
            :key="text.id"
          >
            {{ text.title }}
          </router-link>
        </transition>
      </div>
    </div> -->

    <!-- 右侧图标模块 -->
    <!-- <Transition name="slide-fade">
      <div class="Icon_RightModule" v-show="moduleShow">
        <div
          class="Icon_RightModule_VUp Icon_Module_VUp"
          @click="clickToPrevSlide()"
        >
          <span class="iconfont icon-jiantou-copy"></span>
        </div>
        <div
          class="QQ_Phone"
          @mouseleave="(qqShow = false), (phoneShow = false)"
        >
          <div
            class="Icon_RightModule_QQ"
            @mouseenter="(qqShow = true), (phoneShow = false)"
          >
            <span
              class="iconfont icon-QQ-copy"
              :style="qqShow ? 'color:#fda688' : 'color:#f7c0ae'"
            ></span>
          </div>
          <div class="Icon_RightModule_QQInf" v-show="qqShow">
            <p>品牌咨询</p>
            <p>在线沟通，请点我</p>
            <a href="tencent://message/?uin=29499954&Site=admin5.com&Menu=yes">
              <div class="Icon_RightModule_QQInf_Btn">在线咨询</div>
            </a>
          </div>
          <div
            class="Icon_RightModule_Phone"
            @mouseenter="(qqShow = false), (phoneShow = true)"
          >
            <span
              class="iconfont icon-dianhuatianchong-copy"
              :style="phoneShow ? 'color:#fda688' : 'color:#f7c0ae'"
            ></span>
          </div>
          <div class="Icon_RightModule_PhoneInf" v-show="phoneShow">
            <p>联系电话：</p>
            <p>0571-88173321</p>
          </div>
        </div>

        <div
          class="Icon_RightModule_VDown Icon_Module_VDown"
          @click="clickToNextSlide()"
        >
          <span class="iconfont icon-jiantou-copy1"></span>
        </div>
      </div>
    </Transition> -->
    <!-- 右下角的叉叉 -->
    <!-- <div class="Icon_RightMoudele_Close">
      <span
        class="iconfont icon-chacha-copy"
        @click="(moduleShow = false), (openShow = true), (closeShow = false)"
        v-show="closeShow"
      ></span>
      <span
        class="iconfont icon-chacha-copy1"
        @click="(moduleShow = true), (openShow = false), (closeShow = true)"
        v-show="openShow"
      ></span>
    </div> -->

    <div class="swiper-container swiper-container-v">
      <div class="swiper-wrapper">
        <!-- 首页 -->
        <div class="swiper-slide">
          <div class="swiper-container swiper-container-h">
            <div class="swiper-wrapper">
              <!-- 第一屏 -->
              <div class="swiper-slide HWallPaper1"></div>
              <!-- 第二屏 -->
              <div class="swiper-slide HWallPaper2"></div>
              <!-- 第三屏 -->
              <!-- <div class="swiper-slide HWallPaper3"></div> -->
            </div>
            <div
              class="swiper-pagination swiper-pagination-h"
              ref="myPag"
            ></div>
          </div>
        </div>
        <!-- 服务 -->
        <div class="swiper-slide VWallPaper">
          <div class="server">
            <div class="server_title">业务服务</div>
            <div class="server_icon">
              <ul>
                <router-link
                  tag="a"
                  :to="{
                    path: '/Services',
                    query: { type: '机构服务' },
                  }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img1"></div>
                  <span>机构服务</span>
                </router-link>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '社区养老' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img2"></div>
                  <span>社区养老</span>
                </router-link>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '居家养老' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img3"></div>
                  <span>居家养老</span>
                </router-link>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '老年助餐' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img4"></div>
                  <span>老年助餐</span>
                </router-link>
              </ul>
            </div>
            <div class="server_icon">
              <ul>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '智慧养老' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img5"></div>
                  <span>智慧养老</span>
                </router-link>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '适老改造' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img6"></div>
                  <span>适老改造</span>
                </router-link>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '培训评估' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img7"></div>
                  <span>培训评估</span>
                </router-link>
                <router-link
                  tag="a"
                  :to="{ path: '/Services', query: { type: '规划咨询' } }"
                  target="_blank"
                  @mouseenter.native="moveServerInto($event)"
                  @mouseleave.native="ServerMovedOut($event)"
                >
                  <div class="iconimg img8"></div>
                  <span>规划咨询</span>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
        <!-- 机构 -->
        <div class="swiper-slide VWallPaper">
          <div class="case_carousel" v-if="CasesShow">
            <div class="cases_slogan">机构展示</div>
            <el-carousel
              arrow="never"
              indicator-position="none"
              :autoplay="false"
              ref="cardShow"
            >
              <el-carousel-item
                v-for="url in organsList"
                :key="url.id"
                @click.native="goToCases(url)"
              >
                <!-- <h3 class="medium">{{ item }}</h3> -->
                <div>
                  <img :src="url.coverPictureUrl" alt="" />
                  <p class="el-carousel__title">{{ url.organName }}</p>
                  <p class="el-carousel__content">
                    {{ url.briefIntroduce }}
                  </p>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="caseLeft" @click="caseToPrev">
              <img src="../assets/icon/prev.png" alt="" />
            </div>
            <div class="caseRight" @click="caseToNext">
              <img src="../assets/icon/next.png" alt="" />
            </div>
          </div>
          <!-- 大于800px -->
          <div class="cases" v-if="!CasesShow">
            <!-- 标语 -->
            <div class="cases_slogan">机构展示</div>
            <div class="cases_main">
              <el-carousel
                height="450px"
                style="width: 1600px; margin: auto"
                trigger="click"
                :autoplay="false"
              >
                <el-carousel-item
                  v-for="(item, index) in organsListBox"
                  :key="index"
                >
                  <div
                    class="cases_item"
                    @click="goToCases(i)"
                    @mouseenter="moveCaseInto($event)"
                    @mouseleave="CaseMovedOut($event)"
                    v-for="(i, index_i) in organsListBox[index]"
                    :key="index_i"
                  >
                    <!-- 移入的遮罩 -->
                    <div class="cases_mask">
                      <div></div>
                    </div>
                    <!-- 案例图片 -->
                    <div class="cases_item_img">
                      <img :src="i.coverPictureUrl" alt="" />
                    </div>
                    <!-- 展示的文字 -->
                    <div class="cases_item_text">
                      <p>{{ i.organName }}</p>
                      <span>
                        {{ i.briefIntroduce }}
                      </span>
                    </div>
                    <!-- 移入展示的文字 -->
                    <div class="cases_item_text1">
                      <p>{{ i.organName }}</p>
                      <span>
                        {{ i.briefIntroduce }}
                      </span>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <!-- 合作 -->
        <div class="swiper-slide VWallPaper">
          <div class="Cooperation">
            <!-- 标语 -->
            <div class="Cooperation_slogan">
              <div class="Cooperation_title">合作伙伴</div>
            </div>
            <!-- 内容 -->
            <div class="Cooperation_main">
              <ul>
                <li>
                  <div class="Cooperation_partner1"></div>
                </li>
                <li>
                  <div class="Cooperation_partner2"></div>
                </li>
                <li>
                  <div class="Cooperation_partner3"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 新闻 -->
        <div class="swiper-slide VWallPaper">
          <div class="News">
            <div class="News_slogan">
              <!-- <div class="News_img">
                <img src="../assets/img/news.png" alt="" />
              </div> -->
              <div class="News_title">孝佰汇新闻动态</div>
            </div>
            <div class="News_main">
              <div class="News_left">
                <router-link
                  tag="a"
                  :to="{ path: '/News', query: { id: newArr[0].id } }"
                  target="_blank"
                  v-if="newArr[0]"
                  class="News_item"
                >
                  <p>{{ newArr[0].startTime }}</p>
                  <p>{{ newArr[0].title }}</p>
                </router-link>
                <a v-else></a>
                <a></a>
                <router-link
                  tag="a"
                  :to="{ path: '/News', query: { id: newArr[2].id } }"
                  target="_blank"
                  v-if="newArr[2]"
                  class="News_item"
                >
                  <p>{{ newArr[2].startTime }}</p>
                  <p>{{ newArr[2].title }}</p>
                </router-link>
                <a v-else></a>
                <a></a>
                <router-link
                  tag="a"
                  :to="{ path: '/News', query: { id: newArr[4].id } }"
                  target="_blank"
                  v-if="newArr[4]"
                  class="News_item"
                >
                  <p>{{ newArr[4].startTime }}</p>
                  <p>{{ newArr[4].title }}</p>
                </router-link>
                <a v-else></a>
              </div>
              <div class="News_midImg">
                <div class="News_line">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="News_right">
                <a></a>
                <router-link
                  tag="a"
                  :to="{ path: '/News', query: { id: newArr[1].id } }"
                  target="_blank"
                  v-if="newArr[1]"
                  class="News_item"
                >
                  <p>{{ newArr[1].startTime }}</p>
                  <p>{{ newArr[1].title }}</p>
                </router-link>
                <a v-else></a>
                <a></a>
                <router-link
                  tag="a"
                  :to="{ path: '/News', query: { id: newArr[3].id } }"
                  target="_blank"
                  v-if="newArr[3]"
                  class="News_item"
                >
                  <p>{{ newArr[3].startTime }}</p>
                  <p>{{ newArr[3].title }}</p>
                </router-link>
                <a v-else></a>
                <a></a>
              </div>
            </div>
          </div>
        </div>
        <!-- 关于 -->
        <div class="swiper-slide VWallPaper">
          <div class="About">
            <h3>浙江孝佰汇康养产业发展公司</h3>
            <div class="About_slogan">
              是一家汇集医疗、护理、养老、社工、营养、康复人才，致力于为不同地区、不同年龄、不同状况老年人提供多维度、全方位、高品质服务的养老运营商。
            </div>
            <div class="About_slogan">
              依托集团的养老产业雄厚优势，以“让养老更专业、让晚年更幸福”为使命，以“孝如己亲，佰仁汇集”为服务理念，创建“孝佰汇”品牌。引入日本、中国台湾及江、浙、沪等地区先进、成熟的养老服务理念，协助本地养老体系构建，政策规划、承接养老服务机构、社区养老中心、家庭养老(照护)床位、老年食堂运营、老年能力评估、养老人才培训、养老设施设计提升及适老化改造，并融合智慧养老平台与智能设备，提供特殊对象与居家养老上门服务。用现代化服务理念，标准化服务体系，为老人提供养、医、养、康、护、娱服务。
            </div>
          </div>
        </div>
        <!-- 联系 -->
        <div class="swiper-slide VWallPaper">
          <div class="Contact_all">
            <div class="Contact_title">联系我们</div>
            <div class="Contact">
              <div class="Contact_logo">
                <img src="../assets/img/biglogo.png" alt="" />
              </div>
              <div class="Contact_text">
                <p>中国·杭州</p>
                <p><span>联系电话</span>：13634161501</p>
                <p>
                  <span>联系地址</span
                  >：浙江省杭州市拱墅区复尚发展大厦2单元2002室
                </p>
                <p><span>邮编</span>：310000</p>
                <p>中国·江西</p>
                <p><span>联系电话</span>：0701-6255552</p>
                <p><span>联系地址</span>：江西省鹰潭市信江新区信江大市场</p>
                <p><span>邮编</span>：335000</p>
                <!-- <p>
                Copyright©2022 杭州优医护康养服务有限公司
                <a target="_blank" href="https://beian.miit.gov.cn"
                  >浙ICP备2021014299号</a
                >
                版权所有
              </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList, getServiceList, getOrgansList } from "../axiosAPI";
import Swiper from "swiper";
export default {
  name: "Index",
  data() {
    return {
      NavMenuItem: [
        "首页",
        "服务",
        "机构",
        "合作",
        "新闻",
        "关于我们",
        "联系我们",
      ],
      allLi: [],
      swiper: "",
      swiperH: "",
      number: 0,
      // 新闻
      newArr: [{ title: "", startTime: "" }],
      // 滚动栏
      scrollingShow: true,
      // 右侧模块
      qqShow: false,
      phoneShow: false,
      moduleShow: true,
      closeShow: true,
      openShow: false,
      // 走马灯
      CasesShow: false,
      // 服务列表
      serviceList: [],
      screenWidth: 1920, //屏幕尺寸
      CaseImg: [
        { id: 1, img: require("../assets/img/121.png") },
        { id: 2, img: require("../assets/img/122.png") },
      ],
      caseMore: false,
      // 机构轮播
      organsList: [],
      organsListBox: [],
    };
  },
  watch: {
    screenWidth: {
      handler: function (val) {
        if (val < 750) {
          this.CasesShow = true;
          // });
        } else {
          this.CasesShow = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // 初始化swiper
    this.loadSwiper();
    // 获取新闻列表
    this.getNewList();
    // 获取服务列表
    this.getService();
    // 获取机构列表
    this.getOrgan();
    // 启动文字滚动定时器
    this.startMove();

    // 给每个分页绑定移入事件 鼠标移入横向的分页进行跳转 前提是得写 clickable: true
    for (let i = 0; i < this.swiperH.pagination.bullets.length; i++) {
      this.swiperH.pagination.bullets[i].onmouseover = function () {
        this.click();
      };
    }

    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化就重新赋值
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    // swiper初始化
    loadSwiper() {
      // swiper回调中this指向会被改变
      let that = this;
      // 获取所有的li
      this.allLi = document.getElementsByTagName("li");
      // 手动渲染首页
      this.allLi[0].style.color = "#fff";
      this.allLi[0].children[0].style.backgroundColor = "#fff";
      var mySwiperV = new Swiper(".swiper-container-v", {
        // 分页
        // pagination: ".swiper-pagination",
        // 点击切换
        paginationClickable: true,
        // 垂直滚动
        direction: "vertical",
        // 滚轮滚动
        mousewheel: true,
        on: {
          // 回调函数，swiper从当前slide开始过渡到另一个slide时执行。
          slideChangeTransitionStart() {
            // 滚动同步导航栏样式
            that.NavMenuItem.filter((el, i) => {
              // 点击li不等于遍历的li
              if (this.activeIndex != i) {
                that.allLi[i].className = "";
                that.allLi[i].style.color = "";
                that.allLi[i].style.opacity = "0.5";
                that.allLi[i].children[0].style.backgroundColor = "";
              }
            });
            that.allLi[this.activeIndex].style.color = "#fff";
            that.allLi[this.activeIndex].style.opacity = "1";
            that.allLi[this.activeIndex].children[0].style.backgroundColor =
              "#fff";
            // end
            let navBar = document.getElementsByClassName("NavBar")[0];
            // 不在首页时 改变导航栏样式
            if (this.activeIndex > 0) {
              // 滚动栏
              that.scrollingShow = false;
              navBar.style.animation = "Indent 0.2s linear forwards";
            } else {
              that.scrollingShow = true;
              navBar.style.animation = "Reduction 0.2s linear forwards";
            }
          },
        },
      });
      var mySwiperH = new Swiper(".swiper-container-h", {
        // 点击切换
        paginationClickable: true,
        // 横向滚动
        direction: "horizontal",
        // 循环
        loop: true,
        //3秒切换一次
        autoplay: {
          delay: 3000,
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination-h",
          clickable: true,
        },
      });
      this.swiper = mySwiperV;
      this.swiperH = mySwiperH;
    },
    // 获取服务列表
    getService() {
      getServiceList().then((res) => {
        if (res.data.code == 200) {
          this.serviceList = res.data.item;
          console.log(this.serviceList[0].servicePictureUrl);
        }
      });
    },
    // 获取新闻列表
    getNewList() {
      // JSON.stringify
      // console.log(this.$qs);
      let query = this.$qs.stringify({
        limit: 20,
        page: 1,
        type: "1",
      });
      getNewsList(query).then((res) => {
        if (res.data.code == 200) {
          // if (res.data.item.count < 5) {
          // this.newArr = [];
          // this.startMove()=null
          // }
          this.newArr = res.data.item.item;
        }
      });
    },
    //鼠标点击导航栏
    clickNavBar(e, index) {
      this.NavMenuItem.filter((el, i) => {
        // 点击li不等于遍历出来的li
        // 去除所有li的添加样式
        if (index != i) {
          e.currentTarget.parentElement.children[i].className = "";
          e.currentTarget.parentElement.children[i].style.color = "";
          e.currentTarget.parentElement.children[
            i
          ].children[0].style.backgroundColor = "";
        }
      });
      //   当前点击的li添加样式
      e.currentTarget.style.color = "#fff";
      e.currentTarget.children[0].style.backgroundColor = "#fff";
      //   跳转
      this.clickToSlide(index);
    },
    // 点击跳转slide
    clickToSlide(index) {
      this.swiper.slideTo(index);
    },
    // case上一页
    caseToPrev() {
      this.$refs.cardShow.prev();
    },
    caseToNext() {
      this.$refs.cardShow.next();
    },
    // case下一页
    // 点击上一页slide
    clickToPrevSlide(num) {
      if (num == 2) {
        this.caseSwiper.slidePrev();
      }
      this.swiper.slidePrev();
    },
    // 点击下一页slide
    clickToNextSlide(num) {
      if (num == 2) {
        this.caseSwiper.slideNext();
      }
      this.swiper.slideNext();
    },
    // 鼠标移入导航栏
    moveNavBarInto(e) {
      e.currentTarget.className = "NavMenu_Act";
      e.currentTarget.children[0].className = "liTopBorder";
    },
    // 鼠标移出导航栏
    navBarMovedOut(e) {
      e.currentTarget.className = "";
      e.currentTarget.children[0].className = "";
    },
    // 鼠标移入服务li
    moveServerInto(e) {
      e.currentTarget.style.backgroundColor = "rgba(244,168,29,0.2)";
      // e.currentTarget.children[1].style.color = "#fff";
      // e.currentTarget.children[0].children[0].children[0].style.animation =
      //   "ToRight 0.25s linear forwards";
      // e.currentTarget.children[0].children[0].children[1].style.animation =
      //   "ToRight_1 0.25s linear forwards";
    },
    // 鼠标移出服务li
    ServerMovedOut(e) {
      e.currentTarget.style.backgroundColor = "";
      // e.currentTarget.children[1].style.color = "#000";
      // e.currentTarget.children[0].children[0].children[0].style.animation =
      //   "ToLeft 0.25s linear forwards";
      // e.currentTarget.children[0].children[0].children[1].style.animation =
      //   "ToLeft_1 0.25s linear forwards";
    },
    // 鼠标移入case
    moveCaseInto(e) {
      e.currentTarget.children[0].style.animation =
        "MaskToDown 0.25s linear forwards";
      e.currentTarget.children[3].style.animation =
        "TextToUp 0.25s linear forwards";
    },
    // 鼠标移出case
    CaseMovedOut(e) {
      e.currentTarget.children[0].style.animation =
        "MaskToUp 0.25s linear forwards";
      e.currentTarget.children[3].style.animation =
        "TextToDown 0.25s linear forwards";
    },
    // 鼠标移入partner
    movePartnerInto(e) {
      // e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)";
      e.currentTarget.children[0].style.animation =
        "PartnerToUp1 0.25s linear forwards";
      e.currentTarget.children[1].style.animation =
        "PartnerToUp1_1 0.25s linear forwards";
    },
    // 鼠标移出partner
    PartnerMovedOut(e) {
      // e.currentTarget.style.backgroundColor = "";
      e.currentTarget.children[0].style.animation =
        "PartnerToDown1 0.25s linear forwards";
      e.currentTarget.children[1].style.animation =
        "PartnerToDown1_1 0.25s linear forwards";
    },
    // 文字滚动定时器
    startMove() {
      setTimeout(() => {
        if (this.number === this.newArr.length - 1) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 2500);
    },
    // 机构列表查询
    getOrgan() {
      let query = this.$qs.stringify({
        organName: "",
        type: "1",
      });
      getOrgansList(query).then((res) => {
        if (res.data.code == 200) {
          this.organsList = res.data.item;
          // if (this.organsList.length > 3) {
          //   this.caseMore = true;
          //   this.organsList = this.organsList.splice(0, 3);
          // } else {
          //   this.caseMore = false;
          // }
          var list = [];
          this.organsList.forEach((item, index) => {
            list.push(item);
            if (list.length == 3 || this.organsList.length - 1 == index) {
              this.organsListBox.push(list);
              list = [];
            }
          });
        }
      });
    },
    gotoAllCases() {
      let routerData = this.$router.resolve({ path: "/AllCases" });
      window.open(routerData.href, "_blank");
    },
    // 跳转案例详情
    goToCases(item) {
      let routerData = this.$router.resolve({ path: "/Cases" });
      window.open(routerData.href + "?organName=" + item.organName, "_blank");
    },
    // 跳转新闻详情
    goToNews(item) {
      sessionStorage.setItem("axNewsItem", JSON.stringify(item));
      let routerData = this.$router.resolve({ path: "/News" });
      window.open(routerData.href, "_blank");
    },
  },
  computed: {
    text() {
      return {
        id: this.newArr[this.number].id,
        title: this.newArr[this.number].title,
      };
    },
  },
};
</script>

<style lang="less" scoped>
#Index {
  touch-action: none;
  width: 100vw;
  height: 100vh;
  .NavBar {
    width: 100vw;
    height: 1rem;
    position: fixed;
    z-index: 999;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #f4a81d;
    .Logo {
      margin-left: 0.8rem;
      width: 1.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        zoom: 0.75;
      }
    }
    .NavMenu {
      width: 7rem;
      height: 100%;
      margin-left: 30%;
      .NavMenu_Ul {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        .NavMenu_Act {
          color: #fff;
        }
        li {
          width: 100%;
          height: 100%;
          font-size: 0.22rem;
          color: #fff;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          span {
            display: inline-block;
          }
          p {
            width: 2em;
            height: 3px;
          }
          .liTopBorder {
            background-color: #fff;
          }

          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5) {
            width: 70%;
          }
        }
      }
    }
    .fccLogo {
      width: 1.8rem;
      // width: 15%;
      height: 100%;
      // background-color: rgb(192, 255, 17);
      margin-right: 0.5rem;
      a {
        height: 100%;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          cursor: pointer;
        }
      }
    }
  }
  @media screen and (max-width: 800px) {
    .NavBar {
      .Logo,
      .fccLogo {
        display: none;
      }
      .NavMenu {
        margin: 0 0.5rem;
      }
    }
  }

  // 滚动播报
  .text-container {
    width: 15rem;
    height: 0.5rem;
    position: absolute;
    bottom: 5%;
    left: 2%;
    display: flex;
    align-items: center;
    z-index: 9999;
    .News_down {
      background: url(../assets/img/icon.png) no-repeat 0 -112px;
      width: 47px;
      height: 47px;
      margin-right: 0.2rem;
      cursor: pointer;
    }
    .News_content {
      width: 12rem;
      height: 0.3rem;
      display: flex;
      align-items: baseline;
      font-size: 0.3rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        color: #f7c0ae;
      }
      a {
        cursor: pointer;
        padding-left: 0.15rem;
        font-size: 0.2rem;
        color: #dddddd;
      }
      .slide-enter-active,
      .slide-leave-active {
        transition: all 0.5s linear;
      }
      .slide-leave-to {
        transform: translateY(-20px);
      }
      .slide-enter {
        transform: translateY(20px);
      }
    }
  }
  @media screen and (max-width: 800px) {
    .text-container {
      width: 90vw;
      // overflow: hidden;
      .News_down {
        zoom: 0.8;
        margin-left: 0.2rem;
      }
      .News_content {
        width: 80%;
      }
    }
  }

  // 右侧模块
  .Icon_RightModule {
    width: 0.5rem;
    height: 2.4rem;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.1rem 0 0.1rem 0.05rem;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px 0 0 10px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    span {
      color: #f7c0ae;
      font-size: 0.3rem;
    }
    .Icon_RightModule_VUp {
      height: 0.6rem;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .QQ_Phone {
      .Icon_RightModule_QQ {
        height: 0.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .Icon_RightModule_QQInf {
        width: 1.6rem;
        height: 1.7rem;
        font-size: 0.16rem;
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0.6rem;
        right: 0.55rem;
        border-radius: 10px 0 0 10px;
        z-index: 999;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: left;
        color: #f0f0f0;
        padding-left: 0.2rem;
        box-sizing: border-box;
        a {
          .Icon_RightModule_QQInf_Btn {
            width: 1.2rem;
            height: 0.4rem;
            border: 1px #f7c0ae solid;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #f7c0ae;
            cursor: pointer;
          }
        }
      }
      .Icon_RightModule_Phone {
        height: 0.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .Icon_RightModule_PhoneInf {
        width: 1.6rem;
        height: 0.85rem;
        font-size: 0.18rem;
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 1.2rem;
        right: 0.55rem;
        border-radius: 10px 0 0 10px;
        z-index: 999;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: left;
        color: #f0f0f0;
        padding-left: 0.2rem;
        box-sizing: border-box;
      }
    }
    .Icon_RightModule_VDown {
      height: 0.6rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .slide-fade-enter-active {
    transition: all 0.5s ease-out;
  }

  .slide-fade-leave-active {
    transition: all 0.5s ease-in;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    right: -0.5rem;
    opacity: 0;
  }
  // 模块叉叉
  .Icon_RightMoudele_Close {
    z-index: 999;
    position: fixed;
    right: 10px;
    bottom: 50%;
    margin-bottom: -210px;
    z-index: 999;
    span {
      color: #f7c0ae;
      font-size: 0.3rem;
    }
  }

  @media screen and (max-width: 800px) {
    .Icon_RightModule,
    .Icon_RightMoudele_Close {
      display: none;
    }
  }
  // 混合
  .CenterPage {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
  }
  .swiper-container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .swiper-container-v {
    .swiper-wrapper {
      > .VWallPaper {
        // 服务
        &:nth-child(2) {
          background: url("../assets/img/wallpaper2.png") no-repeat center
            top/cover;
          display: flex;
          align-items: center;
          .server {
            width: 100%;
            height: 6rem;
            margin-bottom: 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .server_title {
              text-align: center;
              font-size: 0.4rem;
              color: #000000;
              letter-spacing: 5px;
              margin-bottom: 0.5rem;
            }
            .server_icon {
              width: 100%;
              display: flex;
              justify-content: center;
              ul {
                width: 60%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                a {
                  width: 200px;
                  // width: 2rem;
                  height: 3rem;
                  display: inline-flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: flex-start;
                  cursor: pointer;
                  .iconimg {
                    width: 157px;
                    height: 157px;
                    margin-top: 0.15rem;
                    position: relative;
                  }

                  @-webkit-keyframes rotate-vert-center {
                    0% {
                      -webkit-transform: rotateY(0);
                      transform: rotateY(0);
                    }
                    100% {
                      -webkit-transform: rotateY(360deg);
                      transform: rotateY(360deg);
                    }
                  }
                  @keyframes rotate-vert-center {
                    0% {
                      -webkit-transform: rotateY(0);
                      transform: rotateY(0);
                    }
                    100% {
                      -webkit-transform: rotateY(360deg);
                      transform: rotateY(360deg);
                    }
                  }
                  .img1 {
                    background: url("../assets/img/server1.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }

                  .img2 {
                    background: url("../assets/img/server2.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }
                  .img3 {
                    background: url("../assets/img/server3.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }
                  .img4 {
                    background: url("../assets/img/server4.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }
                  .img5 {
                    background: url("../assets/img/server5.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }

                  .img6 {
                    background: url("../assets/img/server6.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }
                  .img7 {
                    background: url("../assets/img/server7.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }
                  .img8 {
                    background: url("../assets/img/server8.png") no-repeat;
                    background-size: 157px 157px;
                    &:hover {
                      -webkit-animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                      animation: rotate-vert-center 1s
                        cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
                    }
                  }
                  // .icon_round {
                  //   background: url("../assets/img/server.png") no-repeat -47px -47px;
                  //   width: 157px;
                  //   height: 157px;
                  //   margin-top: 0.15rem;
                  //   position: relative;
                  //   .icon {
                  //     width: 80px;
                  //     height: 70px;
                  //     overflow: hidden;
                  //     .CenterPage();
                  //     .icon1 {
                  //       background: url("../assets/img/server.png") no-repeat;
                  //       width: 81px;
                  //       height: 69px;
                  //       .CenterPage();
                  //     }
                  //     .icon1_1 {
                  //       background: url("../assets/img/server.png") no-repeat -242px -92px;
                  //       width: 81px;
                  //       height: 69px;
                  //       .CenterPage();
                  //       left: -180px;
                  //     }
                  //     .icon2 {
                  //       background: url("../assets/img/server.png") no-repeat -353px -98px;
                  //       width: 80px;
                  //       height: 58px;
                  //       .CenterPage();
                  //     }
                  //     .icon2_2 {
                  //       background: url("../assets/img/server.png") no-repeat -353px -98px;
                  //       width: 80px;
                  //       height: 58px;
                  //       .CenterPage();
                  //       left: -180px;
                  //     }
                  //     .icon3 {
                  //       background: url("../assets/img/server.png") no-repeat -473px -93px;
                  //       width: 61px;
                  //       height: 67px;
                  //       .CenterPage();
                  //     }
                  //     .icon3_3 {
                  //       background: url("../assets/img/server.png") no-repeat -473px -93px;
                  //       width: 61px;
                  //       height: 67px;
                  //       .CenterPage();
                  //       left: -180px;
                  //     }
                  //     .icon4 {
                  //       background: url("../assets/img/server.png") no-repeat -574px -97px;
                  //       width: 58px;
                  //       height: 68px;
                  //       .CenterPage();
                  //     }
                  //     .icon4_4 {
                  //       background: url("../assets/img/server.png") no-repeat -574px -97px;
                  //       width: 58px;
                  //       height: 68px;
                  //       .CenterPage();
                  //       left: -180px;
                  //     }
                  //   }
                  // }
                  span {
                    font-size: 0.25rem;
                    padding: 0.25rem 0;
                    color: #f4a81d;
                  }
                  .serve_text {
                    display: none;
                    p {
                      font-size: 0.225rem;
                      padding: 0.03rem 0;
                    }
                  }
                }
              }
            }
          }
          @media screen and (max-width: 950px) {
            .server_icon {
              ul {
                width: 80% !important;
                .iconimg {
                  zoom: 0.8;
                }
              }
            }
          }
          @media screen and (max-width: 850px) {
            .server_icon {
              ul {
                width: 80% !important;
                .iconimg {
                  zoom: 0.8;
                }
              }
            }
          }
          @media screen and (max-width: 800px) {
            .server_icon {
              ul {
                width: 80% !important;
                .iconimg {
                  zoom: 0.8;
                }
              }
            }
          }

          @media screen and (max-width: 650px) {
            .server_icon {
              ul {
                width: 70% !important;
                .iconimg {
                  zoom: 0.6;
                }
              }
            }
          }
          @media screen and (max-width: 550px) {
            .server {
              height: 4rem !important;
              margin-bottom: 0 !important;
              .server_icon {
                ul {
                  width: 90% !important;
                  .iconimg {
                    zoom: 0.4;
                  }
                }
              }
            }
          }
          @media screen and (max-height: 800px) {
            .server_icon {
              ul {
                width: 80% !important;
                .iconimg {
                  zoom: 0.8;
                }
              }
            }
          }
        }
        // 案例
        &:nth-child(3) {
          background: url("../assets/img/wallpaper3.jpg") no-repeat 100% 100%/100%
            100%;
          display: flex;
          align-items: center;
          .cases {
            width: 100%;
            height: 5.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .cases_slogan {
              font-size: 0.4rem;
              text-align: center;
            }
            .cases_main {
              width: 100%;
              height: 4.2rem;
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              // .el-carousel-item {
              //   width: 400px;
              //   margin: auto;
              // }
              /deep/.el-carousel__container {
                .el-carousel__item {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                }
              }

              .cases_item {
                width: 4rem;
                height: 4.08rem;
                overflow: hidden;
                position: relative;
                cursor: pointer;
                display: inline-block;
                margin: 0 0.4rem;

                .cases_mask {
                  width: 100%;
                  height: 2.08rem;
                  background-color: #00000080;
                  position: absolute;
                  top: -2.35rem;
                  div {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #f7c0aeb3;
                    .CenterPage();
                  }
                }
                .cases_item_img {
                  width: 100%;
                  height: 2.08rem;
                  img {
                    width: 100%;
                    // height: 100%;
                    height: 2.08rem;
                  }
                }
                .cases_item_text {
                  height: 2rem;
                  box-sizing: border-box;
                  padding: 0.1rem 0.2rem;
                  font-size: 0.2rem;
                  line-height: 0.4rem;
                  background-color: #efefef;
                  p {
                    font-size: 0.22rem;
                    color: #1a1a1a;
                  }
                  span {
                    color: #6c6c6c;
                  }
                }
                .cases_item_text1 {
                  height: 2rem;
                  width: 100%;
                  box-sizing: border-box;
                  padding: 0.1rem 0.2rem;
                  font-size: 0.2rem;
                  line-height: 0.4rem;
                  background-color: #ee9578;
                  position: absolute;
                  bottom: -1.9rem;
                  color: #fff;
                  p {
                    font-size: 0.22rem;
                    padding-bottom: 0.1rem;
                  }
                }
              }
              .el-button {
                width: 50px;
                height: 50px;
                background-color: #f4a81d;
                border: #f4a81d;
              }
            }
          }
          @media screen and (max-width: 800px) {
            .swiper {
              .cases_slogan {
                width: 100vw;
                font-size: 0.4rem;
                text-align: center;
                margin-bottom: 0.5rem;
              }
              .swiper-wrapper {
                display: flex;
                justify-content: center;
                .swiper-slide {
                  .cases_item {
                    width: 4rem;
                    height: 4.08rem;
                    margin-left: 1.3rem;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;
                    .cases_item_img {
                      width: 100%;
                      height: 2.08rem;
                      img {
                        width: 100%;
                      }
                    }
                    .cases_item_text {
                      height: 2rem;
                      box-sizing: border-box;
                      padding: 0.1rem 0.2rem;
                      font-size: 0.2rem;
                      line-height: 0.4rem;
                      background-color: #efefef;
                      p {
                        font-size: 0.22rem;
                        color: #1a1a1a;
                      }
                      span {
                        color: #6c6c6c;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        // 合作
        &:nth-child(4) {
          background: url("../assets/img/wallpaper4.jpg") no-repeat 100% 100%/100%
            100%;
          display: flex;
          align-items: center;
          .Cooperation {
            width: 100%;
            height: 6rem;
            margin-bottom: 1.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .Cooperation_slogan {
              display: flex;
              flex-direction: column;
              align-items: center;

              .Cooperation_title {
                margin-top: 1rem;
                font-size: 0.4rem;
                text-align: center;
              }
            }
            .Cooperation_main {
              width: 100%;
              height: 5rem;
              display: flex;
              justify-content: center;
              ul {
                width: 15rem;
                // width: 100%;
                height: 4rem;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                margin-top: 1rem;
                li {
                  overflow: hidden;
                  // width: 260px;
                  // height: 140px;
                  width: 446px;
                  height: 215px;
                  position: relative;
                  background-color: rgba(255, 255, 255, 0.6);
                  margin-bottom: 0.5rem;
                  .Cooperation_partner1 {
                    width: 448px;
                    height: 216px;
                    background: url(../assets/img/partner1.png) no-repeat;
                    background-size: cover;
                  }
                  .Cooperation_partner2 {
                    width: 448px;
                    height: 216px;
                    background: url(../assets/img/partner2.png) no-repeat;
                  }
                  .Cooperation_partner3 {
                    width: 448px;
                    height: 216px;
                    background: url(../assets/img/partner3.png) no-repeat;
                  }
                  &:nth-child(1) {
                    border-left: none;
                    .Cooperation_item1 {
                      background: url(../assets/img/partner.png) no-repeat -328px -34px;
                      width: 95px;
                      height: 120px;
                      .CenterPage();
                    }
                    .Cooperation_item1_up {
                      background: url(../assets/img/partner.png) no-repeat -156px -34px;
                      width: 95px;
                      height: 120px;
                      .CenterPage();
                      bottom: -280px;
                    }
                  }
                  &:nth-child(2) {
                    .Cooperation_item2 {
                      background: url(../assets/img/partner.png) no-repeat -690px -34px;
                      width: 89px;
                      height: 119px;
                      .CenterPage();
                    }
                    .Cooperation_item2_up {
                      background: url(../assets/img/partner.png) no-repeat -537px -34px;
                      width: 89px;
                      height: 119px;
                      .CenterPage();
                      bottom: -280px;
                    }
                  }
                  &:nth-child(3) {
                    .Cooperation_item3 {
                      background: url(../assets/img/partner.png) no-repeat -1031px -42px;
                      width: 143px;
                      height: 111px;
                      .CenterPage();
                    }
                    .Cooperation_item3_up {
                      background: url(../assets/img/partner.png) no-repeat -824px -42px;
                      width: 143px;
                      height: 111px;
                      .CenterPage();
                      bottom: -280px;
                    }
                  }
                  &:nth-child(4) {
                    border-left: none;
                    border-bottom: none;
                    .Cooperation_item4 {
                      background: url(../assets/img/partner.png) no-repeat -368px -291px;
                      width: 212px;
                      height: 69px;
                      .CenterPage();
                    }
                    .Cooperation_item4_up {
                      background: url(../assets/img/partner.png) no-repeat -71px -291px;
                      width: 212px;
                      height: 69px;
                      .CenterPage();
                      bottom: -280px;
                    }
                  }
                  &:nth-child(5) {
                    border-bottom: none;
                    .Cooperation_item5 {
                      background: url(../assets/img/partner.png) no-repeat -846px -269px;
                      width: 122px;
                      height: 91px;
                      .CenterPage();
                    }
                    .Cooperation_item5_up {
                      background: url(../assets/img/partner.png) no-repeat -690px -269px;
                      width: 122px;
                      height: 91px;
                      .CenterPage();
                      bottom: -280px;
                    }
                  }
                  &:nth-child(6) {
                    border-bottom: none;
                    .Cooperation_item6 {
                      background: url(../assets/img/partner.png) no-repeat -1359px -278px;
                      width: 204px;
                      height: 73px;
                      .CenterPage();
                    }
                    .Cooperation_item6_up {
                      background: url(../assets/img/partner.png) no-repeat -1050px -278px;
                      width: 204px;
                      height: 73px;
                      .CenterPage();
                      bottom: -280px;
                    }
                  }
                }
              }
            }
          }
          @media screen and (max-width: 800px) {
            .Cooperation_slogan {
              display: flex;
              flex-direction: column;
              align-items: center;

              .Cooperation_title {
                margin-top: 1rem;
                font-size: 0.4rem;
                text-align: center;
              }
            }
            .Cooperation_main {
              ul {
                width: 6rem !important;
                height: 5rem !important;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around !important;
                margin-top: 1rem !important;
                li {
                  zoom: 0.5;
                  margin-bottom: 0.5rem;
                }
              }
            }
          }
        }
        // 新闻
        &:nth-child(5) {
          background: url("../assets/img/wallpaper5.jpg") no-repeat 100% 100%/100%
            100%;
          display: flex;
          align-items: center;
          .News {
            width: 100%;
            height: 6rem;
            // margin-top: 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            color: #fff;
            .News_slogan {
              // display: flex;
              // flex-direction: column;
              // align-items: center;
              .News_img {
                width: 50%;
                margin-bottom: 0.3rem;
                img {
                  width: 100%;
                }
              }
              .News_title {
                font-size: 0.4rem;
                text-align: center;
              }
            }
            .News_main {
              display: flex;
              font-size: 0.18rem;
              .News_left {
                width: 5rem;
                height: 5rem;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                text-align: right;
                a {
                  color: #fff;
                  height: 0.6rem;
                  p {
                    line-height: 0.3rem;
                  }
                }
              }
              .News_midImg {
                margin: 0 0.5rem;
                .News_line {
                  width: 1px;
                  height: 5rem;
                  background-color: #fff;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: space-around;
                  div {
                    width: 15px;
                    height: 15px;
                    border-radius: 50%;
                    background-color: #fff;
                  }
                }
              }
              .News_right {
                width: 5rem;
                height: 5rem;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                a {
                  color: #fff;
                  height: 0.6rem;
                  p {
                    line-height: 0.3rem;
                  }
                }
              }
              .News_item {
                cursor: pointer;
              }
            }
          }
        }
        // 关于
        &:nth-child(6) {
          background: url("../assets/img/wallpaper6.jpg") no-repeat 100% 100%/100%
            100%;
          display: flex;
          align-items: center;
          .About {
            // width: 86%;
            // height: 6rem;
            // // margin-top: 5.8rem;
            // // margin-left: 1.5rem;
            // position: absolute;
            // color: #000000;
            // display: flex;
            // flex-direction: column;
            // justify-content: center;
            width: 86%;
            height: 100%;
            margin-left: 1.3rem;
            margin-bottom: 0.5rem;
            position: absolute;
            color: #000000;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            h3 {
              font-size: 0.5rem;
              // font-size: 43pt;
              letter-spacing: 3px;
            }
            .About_slogan {
              // text-indent: 2em;
              margin-top: 0.2rem;
              font-size: 0.22rem;
              line-height: 0.38rem;
              letter-spacing: 2px;
              color: #545454;
            }
          }
          @media screen and (max-height: 700px) {
            .About {
              margin-left: 0.5rem;
              margin-bottom: 0.5rem;
              width: 95%;

              h3 {
                font-size: 0.45rem;
                letter-spacing: 2px;
              }
              .About_slogan {
                font-size: 0.25rem;
                margin-top: 0.1rem !important;
                line-height: 0.3rem !important;
                letter-spacing: 0 !important;
              }
              p {
                line-height: 0.2rem !important;
              }
            }
          }
          @media screen and (max-width: 950px) {
            .About {
              margin-left: 0.5rem;
              margin-bottom: 2rem;

              h3 {
                font-size: 0.5rem;
                letter-spacing: 2px;
              }
              .About_slogan {
                font-size: 0.4rem;
                margin-top: 0.3rem !important;
                line-height: 0.5rem !important;
                letter-spacing: 0 !important;
              }
              p {
                line-height: 0.2rem !important;
              }
            }
          }
          @media screen and (max-width: 850px) {
            .About {
              margin-left: 0.5rem;
              margin-bottom: 2rem;

              h3 {
                font-size: 0.5rem;
                letter-spacing: 2px;
              }
              .About_slogan {
                font-size: 0.35rem;
                margin-top: 0.1rem !important;
                line-height: 0.35rem !important;
                letter-spacing: 0 !important;
              }
              p {
                line-height: 0.2rem !important;
              }
            }
          }
          @media screen and (max-width: 750px) {
            .About {
              margin-left: 0.5rem;
              margin-bottom: 1rem;

              h3 {
                font-size: 0.3rem;
                letter-spacing: 2px;
              }
              .About_slogan {
                font-size: 0.22rem !important;
                margin-top: 0.1rem !important;
                line-height: 0.25rem !important;
                letter-spacing: 0 !important;
              }
              p {
                line-height: 0.2rem !important;
              }
            }
          }
          @media screen and (max-width: 450px) {
            .About {
              width: 90%;
              margin-left: 0.3rem;
              margin-bottom: 0.5rem;

              h3 {
                font-size: 0.3rem;
                letter-spacing: 2px;
              }
              .About_slogan {
                font-size: 0.22rem !important;
                margin-top: 0.1rem !important;
                line-height: 0.25rem !important;
                letter-spacing: 0 !important;
              }
              p {
                line-height: 0.2rem !important;
              }
            }
          }
        }
        // 联系
        &:nth-child(7) {
          background: url("../assets/img/wallpaper7.jpg") no-repeat 100% 100%/100%
            100%;
          display: flex;
          align-items: center;

          .Contact_all {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            height: 6rem;
            .Contact_title {
              font-size: 0.4rem;
              text-align: center;
              margin-bottom: 0.5rem;
            }
          }
          .Contact {
            width: 100%;
            height: 4.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 1.5rem;

            // &::after {
            //   width: 65%;
            //   position: absolute;
            //   bottom: 2.3rem;
            //   content: "";
            //   border-bottom: 1px dotted #000;
            // }
            .Contact_logo {
              width: 15%;
              margin: 0 1.5rem 0 1rem;
              img {
                width: 100%;
              }
            }
            .Contact_text {
              font-size: 0.22rem;
              p {
                line-height: 0.4rem;
                letter-spacing: 3px;
              }
              span {
                display: inline-block;
                width: 1.2rem;
                text-align-last: justify;
              }
            }
          }
          @media screen and (max-width: 800px) {
            .Contact_all {
              margin: 0 1rem;
              .Contact_title {
                font-size: 0.4rem;
                text-align: center;
                margin-bottom: 0.5rem;
              }
            }
            .Contact {
              margin: 0 1rem !important;
              // &::after {
              //   width: 80% !important;
              //   bottom: 3.3rem !important;
              // }
              .Contact_logo {
                display: none;
              }
              .Contact_text {
                margin: 0.1rem 0 !important;
                line-height: 0.3rem !important;
                letter-spacing: 0 !important;
                span {
                  display: inline-block;
                  width: 1.1rem;
                  text-align-last: justify;
                }
              }
            }
          }
        }
      }
    }
  }

  .swiper-container-h {
    .swiper-wrapper {
      .HWallPaper1 {
        background: url("../assets/img/wallpaperH1.jpg") no-repeat center
          center/cover;
      }
      .HWallPaper2 {
        background: url("../assets/img/wallpaperH2.jpg") no-repeat center
          center/cover;
      }
      // .HWallPaper3 {
      //   background: url("../assets/img/wallpaperH3.jpg") no-repeat center
      //     center/cover;
      // }
      @media screen and (max-width: 800px) {
        .HWallPaper1 {
          background: url("../assets/img/wallpaperH1m.jpg") no-repeat center
            center/cover;
        }
        .HWallPaper2 {
          background: url("../assets/img/wallpaperH2m.jpg") no-repeat center
            center/cover;
        }
        .HWallPaper3 {
          background: url("../assets/img/wallpaperH3m.jpg") no-repeat center
            center/cover;
        }
      }
    }
  }
}
</style>
<style lang="less">
// 案例
.case_carousel {
  width: 70vw;
  height: 4rem;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  .cases_slogan {
    font-size: 0.4rem;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  .el-carousel--horizontal {
    .el-carousel__container {
      .el-carousel__item {
        div {
          width: 100%;
          height: 80%;

          background-color: #fff;
          img {
            width: 100%;
            max-height: 2rem;
          }
          .el-carousel__title {
            padding: 0 0.2rem;
            font-size: 0.3rem;
          }
          .el-carousel__content {
            padding: 0.1rem 0.2rem;
            margin-top: 0.2rem;
            font-size: 0.2rem;
            line-height: 0.3rem;
          }
        }
      }
    }
  }

  .caseLeft {
    position: absolute;
    top: 50%;
    left: -1rem;
    z-index: 999;
    cursor: pointer;
  }
  .caseRight {
    position: absolute;
    top: 50%;
    right: -1rem;
    cursor: pointer;
  }
}

// 设置swiper分页器样式
.swiper-pagination-bullets {
  left: 7rem !important;
  bottom: 0.2rem !important;
}
span {
  border-radius: 0 !important;
}
.swiper-pagination {
  // --swiper-theme-color: #ff6600 !important;
  --swiper-pagination-color: #ee9578 !important; /* 两种都可以 */
}

.swiper-pagination-bullet {
  width: 0.4rem !important;
  height: 8px !important;
  display: inline-block !important;
}
a {
  text-decoration: none;
  color: #000;
}
// 导航栏
// 缩进
@keyframes Indent {
  from {
    height: 1rem;
    background-color: rgba(0, 0, 0, 0);
  }
  to {
    height: 0.8rem;
    // background-color: rgba(0, 0, 0, 0.5);
    background-color: rgba(244, 168, 29);
  }
}
// 还原
@keyframes Reduction {
  from {
    height: 0.8rem;
    // background-color: rgba(0, 0, 0, 0.5);
    background-color: rgba(244, 168, 29);
  }
  to {
    height: 1rem;
    // background-color: rgba(0, 0, 0, 0);
    background-color: rgb(244, 169, 29);
  }
}
// 服务icon
// 1_1向右
@keyframes ToRight_1 {
  from {
    left: -180px;
  }
  to {
    left: 0;
  }
}
// 1_1回去
@keyframes ToLeft_1 {
  from {
    left: 0;
  }
  to {
    left: -180px;
  }
}
// 1向右
@keyframes ToRight {
  from {
    right: 0;
  }
  to {
    right: -180px;
  }
}
// 1回去
@keyframes ToLeft {
  from {
    right: -180px;
  }
  to {
    right: 0;
  }
}
// 案例

@keyframes MaskToDown {
  from {
    top: -2.08rem;
  }
  to {
    top: 0;
  }
}
@keyframes MaskToUp {
  from {
    top: 0;
  }
  to {
    top: -2.08rem;
  }
}
@keyframes TextToUp {
  from {
    bottom: -1.9rem;
  }
  to {
    bottom: 0;
  }
}
@keyframes TextToDown {
  from {
    bottom: 0;
  }
  to {
    bottom: -1.9rem;
  }
}
// 合作
@keyframes PartnerToUp1 {
  from {
    top: 0;
  }
  to {
    top: -280px;
  }
}
@keyframes PartnerToDown1 {
  from {
    top: -280px;
  }
  to {
    top: 0;
  }
}
@keyframes PartnerToUp1_1 {
  from {
    bottom: -280px;
  }
  to {
    bottom: 0;
  }
}
@keyframes PartnerToDown1_1 {
  from {
    bottom: 0;
  }
  to {
    bottom: -280px;
  }
}
</style>
